import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {PlayersStatisticsTableDomainModel} from "../../../domain/yard/lineups/players-statistics/tables/players-statistics.table.domain-model";
import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {PlayersStatisticsTableColumnViewModel} from "../../../domain/yard/lineups/players-statistics/tables/columns/players-statistics.table.column.view-model";
import {PlayersStatisticsTableRowSummaryRowViewModel} from "../../../domain/yard/lineups/players-statistics/tables/rows/summary/players-statistics.table.row.summary-row.view-model";
import {PlayersStatisticsTableRowMemberRowViewModel} from "../../../domain/yard/lineups/players-statistics/tables/rows/member/players-statistics.table.row.member-row.view-model";
import {computed} from "mobx";
import {
  PlayersStatisticsTableColumnGroupViewModel
} from "../../../domain/yard/lineups/players-statistics/tables/columnsGroups/players-statistics.table.column-group.view-model";
import type {
  PlayersStatisticsTableColumnGroupDomainModel
} from "../../../domain/yard/lineups/players-statistics/tables/columnsGroups/players-statistics.table.column-group.domain-model";

export class BoxScoresTableViewModel extends BaseViewModel {
  #table: PlayersStatisticsTableDomainModel;
  #isMajorValues: Boolean;

  constructor(model: BaseDomainModel, table: PlayersStatisticsTableDomainModel, isMajorValues) {
    super(model);

    this.#table = table;
    this.#isMajorValues = isMajorValues;
  }

  @computed get rows(): Array<PlayersStatisticsTableRowMemberRowViewModel> {
    const rows: Array<PlayersStatisticsTableRowMemberRowViewModel> = this.#table?.rows.map(row => new PlayersStatisticsTableRowMemberRowViewModel(row, this.columns)).filter((row: PlayersStatisticsTableRowMemberRowViewModel) => !row.groupId || row.groupId === this.id);

    return rows;
  }

  @computed get columns(): Array<PlayersStatisticsTableColumnViewModel> {
    const columns: Array<PlayersStatisticsTableColumnViewModel> = this.#table?.columns.map((column :PlayersStatisticsTableColumnViewModel) => new PlayersStatisticsTableColumnViewModel(column));
    const isMajorColumns: Array<PlayersStatisticsTableColumnViewModel> = this.#table?.columns.filter((column :PlayersStatisticsTableColumnViewModel) => column.isMajor).map(column => new PlayersStatisticsTableColumnViewModel(column));

    return this.#isMajorValues ? isMajorColumns : columns ;
  }

  @computed get summary(): Array<PlayersStatisticsTableRowSummaryRowViewModel> {
    const summary: Array<PlayersStatisticsTableRowSummaryRowViewModel> = this.#table?.summary?.map((summary: PlayersStatisticsTableRowSummaryRowViewModel) => new PlayersStatisticsTableRowSummaryRowViewModel(summary, this.columns));
    const lastGroupId: Boolean = this.#table.groups?.last().id === this.id;
    const isCategories: Boolean = !!this.#table.categoryId;

    return isCategories || lastGroupId ? summary : []
  }

  @computed get columnGroups(): Array<PlayersStatisticsTableColumnGroupViewModel> {
    const columnGroups: Array<PlayersStatisticsTableColumnGroupViewModel> = this.#table?.columnGroups?.map((columnGroup :PlayersStatisticsTableColumnGroupDomainModel) => {
      const columns = this.columns.filter((column :PlayersStatisticsTableColumnViewModel) => column.columnGroup === columnGroup.order);
      return new PlayersStatisticsTableColumnGroupViewModel(columnGroup, columns)
    });

    return columnGroups;
  }
}